const NiceDate = ({ date }) => {
  const formatted = new Date(date).toLocaleString('pt-BR', {
    dateStyle: 'long'
  })

  return formatted
}

export default NiceDate
